import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ReportInstanceMetadata } from 'src/app/configs/model/reports.model';
import { BeastService } from 'src/app/services/beast.service';
import { CorpFinService } from 'src/app/services/corp-fin.service';

@Component({
  selector: 'rule-5190-report',
  templateUrl: './rule-5190-report.component.html',
  styleUrls: ['./rule-5190-report.component.scss']
})
export class Rule5190ReportComponent implements OnInit {

  @Input()
  reportInstanceMetadata: ReportInstanceMetadata;

  @Input() tables;

  @Input() tableNames;

  _columnDefs = {};

  @Input()
  get columnDefs(): object {
    return this._columnDefs;
  }

  set columnDefs(columnDefs: object) {
    this._columnDefs = columnDefs;
  }

  _rowData: object[];

  @Input() tableData: object;
  @Input() chartData: object;
  
  @Input()
  get rowData(): object[] {
    return this._rowData;
  }

  set rowData(rowData: object[]) {
    this._rowData = rowData;
  }

  lineChartOptions = {
    submissionTotals: {
      xAxisLabel: "Quarter",
      yAxisLabel: "Rate %"
    },
    exceptionType: {
      xAxisLabel: "Quarter",
      yAxisLabel: "Count"
    }
  }

  gridOptions = {
    groupIncludeTotalFooter: false,
    headerHeight: 48,
    groupHeaderHeight: 48
  };

  colorScheme = {
    domain: [
      '#66B4E3', // Blue 50
      '#FFDF1A', // Yellow 50
      '#B15FFF', // Purple 50
      '#FF5775', // Red 50
      '#1CB7B4', // Teal 50
      '#4CD151', // Green 50
      '#AAAAAA', // Gray 50

      '#00619C', // Blue 80
      '#F7A906', // Yellow 80
      '#500BA8', // Purple 80
      '#BC0C31', // Red 80
      '#06405E', // Teal 80
      '#046950', // Green 80
      '#4A4A4A', // Gray 80
      
      '#CCE6F6', // Blue 20
      '#FFE9AD', // Yellow 20
      '#E6C8FF', // Purple 20
      '#FFCDD8', // Red 20
      '#AAF4F2'  // Teal 20
    ]
  };

  customColorsFunction = (name: string) => {
    const colorMap = {
      'Acquisition':                '#BDF2C0', // Green 20
      'At the Market':              '#FFC71A', // Yellow 70
      'Bought Deal':                '#339BDA', // Blue 60
      'Block':                      '#0070B7', // Blue 70
      'Bank Conversion':            '#C65301', // Yellow 100
      'Best Efforts':               '#1CB7B4', // Teal 50
      'Convertible Debt':           '#FDEFC6', // Yellow 10
      'Convertible Equity':         '#D3D8E0', // Slate 30
      'Exchange Offer':             '#FE8CA5', // Red 40
      'Follow On':                  '#A0DBFF', // Blue 30
      'IPO':                        '#730EDD', // Purple 70
      'Merger':                     '#F5EDFD', // Purple 10
      'Non-Convertible Debt':       '#044F2B', // Green 90
      'Non-Convertible Preferred':  '#980725', // Red 90
      'Other':                      '#CCF8F8', // Teal 10
      'Private Placement or PIPE':  '#B15FFF', // Purple 50
      'Registered Direct':          '#E1A7FF', // Purple 30
      'Registered':                 '#79EFED', // Teal 30
      'Rights Offering':            '#FFEBF0'  // Red 10
    };
    return colorMap[name] || undefined;
  };


  viewType = 'table';

  constructor(
    private corpFinService: CorpFinService,
    public datepipe: DatePipe,
    private beastService: BeastService,
  ) {
    this.corpFinService.setViewType('table');
  }

  ngOnInit(): void {
    this.corpFinService.getViewTypeSubject().subscribe(
      (viewType: string) => this.viewType = viewType
    )
  }

  switchView(viewType) {
    this.corpFinService.setViewType(viewType);
  }

  showView(viewType) {
    const currentViewType = this.corpFinService.getViewType();
    return ['all', viewType].includes(currentViewType);
  }

  formatPercent(data) {
    return data + "%" 
  }
}